<template>
  <div class="background-tilt" />
</template>

<script>
  export default {
    name: "BackgroundTilt"
  }
</script>

<style scoped>
  div {
    position: absolute;
    display: block;
    top: 0;
    left: -5px;
    right: 5px;
    bottom: 0;
    margin: calc(-40vh + 100px) -5vh -40vh;
    background: linear-gradient(174deg, #99a5bb 0%, white 40%);
    transform: rotate(6deg);
  }
</style>